import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  getScreenAppUrl,
  getTenantQrStyleUrl,
} from "../../app/helpers/urlHelper";
import { translationHookOptions } from "../../app/localization/localization";
import { IScreenStatus } from "../../app/models/screens";
import { getDisplayName } from "../../app/models/user";
import { RootStoreContext } from "../../app/stores/rootStore";
import QRCodeComponent from "../common/QRCodeComponent";
import { Button, UncontrolledTooltip } from "reactstrap";
import "../../assets/scss/buttons.scss";
import { toast } from "react-toastify";

interface IParams {
  screen: IScreenStatus;
}

const PersonalScreenQrButton: React.FC<IParams> = ({
  screen,
}) => {
  const rootStore = useContext(RootStoreContext);
  const { currentTenant, ScreenQrWidgetEvent } = rootStore.tenantStore;
  const { user } = rootStore.userStore;
  const { theme } = rootStore.commonStore;
  const [t] = useTranslation(["browse_page"], translationHookOptions);
  const screenUrl = `${getScreenAppUrl()}/${screen.url}`;
  const divTextRef = React.useRef() as React.MutableRefObject<HTMLInputElement>;
  const divQrRef = React.useRef() as React.MutableRefObject<HTMLInputElement>;
  const targetRef = React.useRef() as React.MutableRefObject<HTMLInputElement>;

  const [sizeQr, setSizeQr] = useState({ width: 0, margin: 0 });
  const [textSize, setTextSize] = useState(0);
  const [isQrVisible, setIsQrVisible] = useState(false);
  const [isSizeRight, setIsSizeRight] = useState(false);

  useEffect(() => {
    manageElementSize();

    window.addEventListener("resize", manageElementSize);
    return () => {
      window.removeEventListener("resize", manageElementSize);
    };
  }, [isSizeRight]);

  const manageElementSize = () => {
    setIsQrVisible(false);

    //controlliamo che i ref siano stati renderizzati
    if (targetRef.current && divQrRef.current && divTextRef.current) {
        //controlliamo che la width dei ref non sia maggiore di quella del body
      if (
        divQrRef.current.offsetWidth > document.body.offsetWidth ||
        divQrRef.current.offsetHeight > document.body.offsetHeight
      ) {
        setIsSizeRight(!isSizeRight);
      } else {
        if (divQrRef.current.offsetWidth > document.body.offsetHeight) {
          //se larghezza maggiore dell'altezza
          setSizeQr({
            width: document.body.offsetHeight * 0.5,
            margin: document.body.offsetHeight * 0.02,
          });
          setTextSize(document.body.offsetHeight * 0.04);
        } else {
          //se altezza maggiore della larghezza
            setSizeQr({
              width: divQrRef.current.offsetWidth * 0.7,
              margin: divQrRef.current.offsetWidth * 0.02,
            });
            setTextSize(divTextRef.current.offsetWidth * 0.04);
        }
        setIsQrVisible(true);
      }
    }
  };
  const handleCopy = async (url: string) => {
    await navigator.clipboard.writeText(url);
    toast.success(t("screens_url_copy"));
  }

  return (
    <>
      <div className="text-center widgetScreenQr" ref={targetRef}>
        <div
          style={{ fontSize: textSize }}
          className="textDiv textQr"
          ref={divTextRef}
        >
          <div className="tooltip-wrapper">
          <Button
            id={"copy"}
            className="buttonSimple buttonSimpleEffect"
            outline //queste 2 impostazione sono obbigatorie per contrastare gli effetti generici dei bottoni sul player, boxShadow: 'none'
            style={{ boxShadow: 'none',color: "black", marginTop:"-5px", marginLeft:"-5px",fontSize:"20px", paddingTop:"0px", paddingBottom:"0px" }}
            onClick={() => handleCopy(screenUrl)}
          >
            <span className="btn-inner--icon">
            <i className="fas fa-clipboard fa-lg"></i>
            </span>
          </Button>
          <UncontrolledTooltip
            delay={0}
            placement="top"
            target={`copy`}
          >
            Copia Url
          </UncontrolledTooltip>
            <b style={{fontSize: "28px"}}>{screenUrl}</b>
          </div>
         
        </div>
        <div ref={divQrRef} className="qrDiv">
          {isQrVisible ? (
            <QRCodeComponent
              data={`${screenUrl}?code=${screen.code}`}
              remoteOptionsUrl={getTenantQrStyleUrl(currentTenant!)}
              size={sizeQr.width}
            />
          ) : null}
        </div>
        {true && (
          <button
            style={{ fontSize: textSize }}
            className={classNames(
              "screenButton mt-2",
              `${theme!.buttonColor} ${theme!.buttonBorderColor} ${
                theme!.buttonTextColor
              }`
            )}
            onClick={() =>
              ScreenQrWidgetEvent(screenUrl, screen.code, getDisplayName(user!))
            }
          >
            {t("screens_personal_showqr_modal_button")}
          </button>
        )}
      </div>
    </>
  );
};

export default observer(PersonalScreenQrButton);
